import { View, StyleSheet } from 'react-native';
import { getScreenHeight, getScreenWidth } from '../utils/LayoutUtility';
import { useEffect } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import { API_DOMAIN, WEB_URL } from '../config/Constants';
import { resolveRestrictedShortLink } from '../utils/ApiCallingUtility';
import DynamicLinkManager from '../utils/DynamicLinkManager';
import { navigateToScreen } from '../utils/NavigationUtility';
import { isBlank } from '../utils/BooleanUtility';

const DynamicLinkHandlerPage = () => {
  const routes = useRoute();
  const { id } = routes.params;
  const navigation = useNavigation();
  useEffect(() => {
    const handleDynamicLink = async () => {
      const modifiedUrl = `${API_DOMAIN}/api/v1/links/${id}`;
      const { changedSlug } = await resolveRestrictedShortLink(modifiedUrl);
      const url = `${WEB_URL}${changedSlug}`;
      if (isBlank(changedSlug)) {
        window.location.href = "feed";
        return;
      }
      DynamicLinkManager.handleLinkWithInternalTrackingParams(
        url,
        ({ route = '', slug = '', extra = {} }) => {
          navigateToScreen({
            navigation,
            type: 'replace',
            screen: route,
            params: { slug, extra },
          });
        }
      );
    };
    handleDynamicLink();
  }, []);
  return (
    <View style={styles.dynamicLinkHandlerPageContainer} />
  )
}

export default DynamicLinkHandlerPage;

const styles = StyleSheet.create({
  dynamicLinkHandlerPageContainer: {
    width: getScreenWidth(),
    height: getScreenHeight(),
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center'
  }
})